import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class ShuftiRequestService {
  constructor(private http: HttpClient) { }

  getVerificationVideo$(url: string, accessToken: string): Observable<Blob> {
    return this.http.post(url, { access_token: accessToken }, { responseType: 'blob' });
  }
}